import React, {useState, useEffect} from 'react';
import Api from "../../../lib/Api";
import Newsletter from "../../../lib/Newsletter"
import {useTranslation} from "react-i18next";
import Popup from "../../../lib/Popup";

const MailPopup = ({bikes, data, traject}) => {
    const [t] = useTranslation('result');
    const [loading, setLoading] = useState(false);
    const [firstName, setFirstName] = useState(Newsletter.getLocalEntry().firstname || '');
    const [email, setEmail] = useState(Newsletter.getLocalEntry().email || '');
    const [optinData, setOptinData] = useState(Newsletter.getLocalEntry().optinData || false);
    const [optinMail, setOptinMail] = useState(Newsletter.getLocalEntry().optinMail || false);
    const [policy, setPolicy] = useState(Newsletter.getLocalEntry().policy || false);
    const [error, setError] = useState('');

    const [imageOne, setImageOne] = useState('');
    const [imageTwo, setImageTwo] = useState('');
    const [imageThree, setImageThree] = useState('');

    // const [experience, setExperience] = useState('');
    // const [position, setPosition] = useState('');
    // const [frameType, setFrameType] = useState('');
    // const [suspension, setSuspension] = useState('');

    useEffect(() => {
        if (bikes[0])
            toDataURL("/img/bikes/" + bikes[0].bike_model.picture, dataUrl => { setImageOne(dataUrl) })
        if (bikes[1])
            toDataURL("/img/bikes/" + bikes[1].bike_model.picture, dataUrl => { setImageTwo(dataUrl) })
        if (bikes[2])
            toDataURL("/img/bikes/" + bikes[2].bike_model.picture, dataUrl => { setImageThree(dataUrl) })
    }, [bikes])

    // useEffect(() => {
    //     Api.get("/experience", { bike_cat: traject }).then(response => {
    //         for (let elm of Object.values(response.data.data)) {
    //             if (elm.id === data.experience) { setExperience(elm.experience); }
    //         }
    //     });
    //     Api.get('/position', {bike_cat: traject}).then(response => {
		// 	for (let elm of Object.values(response.data.data)) {
    //             if (elm.id === data.position) { setPosition(elm.title); }
    //         }
    //     })
    //     Api.get("/gender").then((response) => {
    //         for (let elm of Object.values(response.data.data)) {
    //             if (elm.id === data.gender) { setFrameType(elm.gender); }
    //         }
    //     });
    //     Api.get('/suspension').then(response => {
		// 	for (let elm of Object.values(response.data.data)) {
    //             if (elm.id === data.gender) { setSuspension(elm.intro); }
    //         }
		// })
    // }, [traject]);

    const mailReport = (e) => {
        e.preventDefault();

        if ( ! policy) {
            setError(t('MAIL_POPUP_Policy_Error'))
            return;
        }

        setLoading(true)

        Newsletter.setEntry({
            firstname: firstName,
            email: email,
            optinMail: optinMail,
            optinData: optinData,
            policy: policy
        })

        let postData = {
            bike_one: bikes[0] ? {
                name: bikes[0].bike_model.brand + " " + bikes[0].bike_model.model,
                image: imageOne,
                size: bikes[0].summary.bike_size,
                price: bikes[0].summary.price.toLocaleString("nl"),
                weight: bikes[0].bike_model.weight ? Math.round(bikes[0].bike_model.weight / 100) / 10 + " kg" : t("Result_NotAvailable"),
                material: bikes[0].bike_model.frame_material ? bikes[0].summary.frame_material : t("Result_NotAvailable"),
                fit: bikes[0].summary.fit !== null ? Math.round(bikes[0].summary.fit / 10).toString() : false,
                chain: bikes[0].summary.drive_chain !== null ? Math.round(bikes[0].summary.drive_chain / 10).toString() : false,
                suspension: bikes[0].summary.suspension !== null ? Math.round(bikes[0].summary.suspension / 10).toString() : false,
                brakes: bikes[0].summary.brakes !== null ? Math.round(bikes[0].summary.brakes / 10).toString() : false,
                wheels: bikes[0].summary.wheels !== null ? Math.round(bikes[0].summary.wheels / 10).toString() : false,
                frame: bikes[0].summary.frame !== null ? Math.round(bikes[0].summary.frame / 10).toString() :false
            } : null,
            bike_two: bikes[1] ? {
                name: bikes[1].bike_model.brand + " " + bikes[1].bike_model.model,
                image: imageTwo,
                size: bikes[1].summary.bike_size,
                price: bikes[1].summary.price.toLocaleString("nl"),
                weight: bikes[1].bike_model.weight ? Math.round(bikes[1].bike_model.weight / 100) / 10 + " kg" : t("Result_NotAvailable"),
                material: bikes[1].bike_model.frame_material ? bikes[1].summary.frame_material : t("Result_NotAvailable"),
                fit: bikes[1].summary.fit !== null ?
                Math.round(bikes[1].summary.fit / 10).toString() : false,
                chain: bikes[1].summary.drive_chain !== null ? Math.round(bikes[1].summary.drive_chain / 10).toString() : false,
                suspension: bikes[1].summary.suspension !== null ? Math.round(bikes[1].summary.suspension / 10).toString() : false,
                brakes: bikes[1].summary.brakes !== null ? Math.round(bikes[1].summary.brakes / 10).toString() : false,
                wheels: bikes[1].summary.wheels !== null ? Math.round(bikes[1].summary.wheels / 10).toString() : false,
                frame: bikes[1].summary.frame !== null ? Math.round(bikes[1].summary.frame / 10).toString() : false
            } : null,
            bike_three: bikes[2] ? {
                name: bikes[2].bike_model.brand + " " + bikes[2].bike_model.model,
                image: imageThree,
                size: bikes[2].summary.bike_size,
                price: bikes[2].summary.price.toLocaleString("nl"),
                weight: bikes[2].bike_model.weight ? Math.round(bikes[2].bike_model.weight / 100) / 10 + " kg" : t("Result_NotAvailable"),
                material: bikes[2].bike_model.frame_material ? bikes[2].summary.frame_material : t("Result_NotAvailable"),
                fit: bikes[2].summary.fit !== null ? Math.round(bikes[2].summary.fit / 10).toString() : false,
                chain: bikes[2].summary.drive_chain !== null ? Math.round(bikes[2].summary.drive_chain / 10).toString() : false,
                suspension: bikes[2].summary.suspension !== null ? Math.round(bikes[2].summary.suspension / 10).toString() : false,
                brakes: bikes[2].summary.brakes !== null ? Math.round(bikes[2].summary.brakes / 10).toString() : false,
                wheels: bikes[2].summary.wheels !== null ? Math.round(bikes[2].summary.wheels / 10).toString() : false,
                frame: bikes[2].summary.frame !== null ? Math.round(bikes[2].summary.frame / 10).toString() :false
            } : null,
            // experience: experience,
            // position: position,
            // frameType: frameType,
            // suspension: suspension,
            // brands: data.brands ? data.brands.join() : '',
            // frameMaterial: data.frame ? data.frame.join() : '',
            // traject: traject,
            year: data.year,
            bike_cat: data.bikeCat,
            bike_type: data.bikeType,
            measure: data.measure,
            position: data.position,
            back_angle: data.backAngle,
            max_price: data.maxPrice,
            email: email,
            firstName: firstName
        }
        Api.post('/bikefinder-summary-report', postData)
            .then((response) => {
                console.log(response)
                Popup.close()
            }
        )
    }

    function toDataURL(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function() {
          var reader = new FileReader();
          reader.onloadend = function() {
            callback(reader.result);
          }
          reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    }

    const inputEmail = e => setEmail(e.target.value)
    const inputFirstName = e => setFirstName(e.target.value)
    const changeOptinMail = e => setOptinMail(e.target.checked)
    const changeOptinData = e => setOptinData(e.target.checked)
    const changePolicy = e => setPolicy(e.target.checked)

    return (
        <form onSubmit={mailReport}>
            <h3>{t('MAIL_POPUP_TITLE')}</h3>
            <div className="row">
                <div className="col-md-12">
                    {error !== '' && (
                      <div className="alert alert-danger">
                          {error}
                      </div>
                    )}
                    <div className="form-group">
                        <input type="text" onChange={inputFirstName} className="form-control"
                               placeholder={t('MAIL_POPUP_FIRSTNAME')} value={firstName}
                               required="required" />
                    </div>
                    <div className="form-group">
                        <input type="email" name="email" onChange={inputEmail} className="form-control"
                               placeholder={t('MAIL_POPUP_EMAIL')} value={email}
                               required="required" />
                    </div>
                    <div className="form-check">
                            <input type="checkbox" checked={optinMail} onChange={changeOptinMail}
                                    className="form-check-input" id="optin_mail"/>
                            <label className="form-check-label"
                                    htmlFor="optin_mail">{t('MAIL_POPUP_OptinMail')}</label>
                    </div>
                    <div className="form-check">
                        <input type="checkbox" checked={optinData} onChange={changeOptinData}
                                className="form-check-input" id="optin_data"/>
                        <label className="form-check-label"
                                htmlFor="optin_data">{t('MAIL_POPUP_OptinData')}</label>
                    </div>
                    <div className="form-check">
                        <input type="checkbox" checked={policy} onChange={changePolicy}
                                className="form-check-input" id="policy"/>
                        <label className="form-check-label"
                                htmlFor="policy">{t('MAIL_POPUP_Policy')}</label>
                    </div>

                </div>
            </div>
            <div className="row mt-4">
                <div className="col-6">
                    <input type="submit" name="btnSubmit" className="btn btn-secondary" disabled={loading}
                            value={t('MAIL_POPUP_SUBMIT')}/>
                </div>
                <div className="col-6 text-right">

                </div>
            </div>
        </form>
    );
}

export default MailPopup;
